export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHElEQVR42mNgYGD4TyEGEf/JxKMGjBpAXQPIxwCKFErEf0l8bAAAAABJRU5ErkJggg=="